import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Navigation } from "lucide-react";

export default function NearbyCounter() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    navigator.geolocation?.getCurrentPosition(async (pos) => {
      try {
        const { data } = await api.get("/items", {
          params: { status: "available", lat: pos.coords.latitude,
                    lng: pos.coords.longitude, radius_km: 10 },
        });
        setCount(Array.isArray(data) ? data.length : 0);
      } catch (err) { console.warn("NearbyCounter fetch failed", err); }
    }, () => {}, { timeout: 6000 });
  }, []);

  if (count === null || count === 0) return null;

  return (
    <div data-testid="nearby-counter"
      className="inline-flex items-center gap-2 px-4 h-11 rounded-full bg-[#0F0F12] text-white text-sm">
      <Navigation className="h-3.5 w-3.5 text-[#7C3AED]" />
      <strong>{count}</strong> live within 10 km
    </div>
  );
}
